import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Card } from "../ui/card";
import { fmtDateTime } from "./dpaUtils";

const show = (v) => (v == null ? "" : typeof v === "object" ? JSON.stringify(v) : String(v));

export const AuditRows = ({ items }) => (
  <div className="divide-y" style={{ borderColor: "var(--hi-border)" }}>
    {items.map((e) => (
      <div key={e.id} className="py-2 text-xs" data-testid="dpa-audit-row">
        <span className="font-mono text-muted-foreground">{fmtDateTime(e.at)}</span> · <span className="font-semibold">{e.event.replace(/_/g, " ")}</span>
        {e.agreement_ref && <span className="font-mono"> · {e.agreement_ref}</span>} · {e.actor_email}{e.note && ` · ${e.note}`}
        {e.after && Object.keys(e.after).length > 0 && (
          <div className="text-muted-foreground truncate" title={show(e.after)}>
            {Object.keys(e.after).map((k) => `${k}: ${show(e.before?.[k]) || "—"} → ${show(e.after[k]) || "—"}`).join(" · ")}
          </div>
        )}
      </div>
    ))}
    {!items.length && <div className="text-xs text-muted-foreground py-2">No activity yet.</div>}
  </div>
);

export const DpaAuditTab = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/dpa/audit").then(({ data }) => setItems(data.items)); }, []);
  return <Card className="rounded-none p-6" data-testid="dpa-audit-tab"><AuditRows items={items} /></Card>;
};
